import { Injectable } from '@angular/core';

import { BetslipType } from '../../../core/betslip-type';
import { BetslipPick } from '../../../core/picks/betslip-pick';
import { isBetslipBetBuilderPick } from '../../../core/utils';
import { IBetBuilderPickState } from '../../bet-builder/models';
import { isBetStationFreebetToken } from '../../reward-tokens/services/betstation-reward-tokens.utils';
import { isFreebetToken } from '../../reward-tokens/services/reward-tokens.utils';
import { hasCriticalBetslipAndTypeErrorForType, hasCriticalErrorForSlip } from '../../validation/services/utils/betslip-errors-utils';
import { ICalculatorBetslipInput } from '../models';
import { ComboSlipType, SingleSlipType, SlipType } from '../slip-type';
import BaseInputBuilder, { BetslipStateInput, InputBuilderGeneratorOptions } from './base-input-builder';
import { getBetBuilderSlipId } from './slip.utils';

@Injectable()
export default class BetBuilderBetInputBuilder extends BaseInputBuilder {
    *getBetGeneratorInput(
        betslipState: BetslipStateInput,
        options: Required<InputBuilderGeneratorOptions<IBetBuilderPickState>>,
    ): Iterable<ICalculatorBetslipInput> {
        const betBuilderPicks = options.picksSelector(betslipState);

        for (const [pickId, betBuilderBetPick] of betBuilderPicks) {
            const rewardTokenId = betBuilderBetPick.rewardTokenId;

            const pick = betslipState.picks.pickList.find((p) => p.id.isEqual(pickId));
            if (!pick) {
                continue;
            }

            const rewardToken = this.getSelectedTokenIfEligible(rewardTokenId, betslipState.rewardTokens, betslipState.types, {
                betslipType: BetslipType.BetBuilder,
                pickId: pick.id,
            });

            const stake = isBetStationFreebetToken(rewardToken) || isFreebetToken(rewardToken) ? rewardToken.amount : betBuilderBetPick.stake;

            yield {
                slipId: getBetBuilderSlipId(pick.id),
                items: [
                    {
                        ...this.getPickInfo(pick),
                        eachWayInfo: null,
                        isBanker: false,
                        isXCast: false,
                        isStartingPrice: false,
                    },
                ],
                rewardToken,
                stake,
                system: this.resolveSystemType(pick),
                hasError:
                    hasCriticalBetslipAndTypeErrorForType(betslipState.errors, BetslipType.BetBuilder) ||
                    hasCriticalErrorForSlip(betslipState.errors, getBetBuilderSlipId(pick.id)),
            };
        }
    }

    private resolveSystemType(pick: BetslipPick): SlipType {
        return isBetslipBetBuilderPick(pick) ? new SingleSlipType() : new ComboSlipType();
    }
}
